/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ExamLabDetailsAliases {
  BREADCRUMB_DETAILS_EXAM_LAB_DETAILS = 'breadcrumb-details-exam-lab-details',
  BUTTON_EMAIL = 'button-email',
  CARD_EXAMS_ESTABLISHMENT_INFORMATION_RIGHT_CARD_EXAM_LAB_DETAILS = 'card-exams-establishment-information-right-card-exam-lab-details',
  CARD_EXAMS_INFORMATION = 'card-exams-information',
  CARD_EXAMS_LIST_ITEM = 'card-exams-list-item',
  CARD_EXAMS_LIST_ITEM_AVAILABLE = 'card-exams-list-item-available',
  CARD_EXAMS_LIST_ITEM_PROCESSING = 'card-exams-list-item-processing',
  CARD_EXAMS_TITLE_EXAMS_LAB_TITLE_EXAM_LAB_DETAILS = 'card-exams-title-exams-lab-title-exam-lab-details',
  CONTEXTUAL_BAR_EXAM_LAB_DETAILS_EXAM_LAB_DETAILS = 'contextual-bar-exam-lab-details-exam-lab-details',
  DECK_EXAMS = 'deck-exams',
  DECK_EXAMS_AVAILABLE = 'deck-exams-available',
  DOWNLOAD_EXAM_BTN = 'download-exam-btn',
  FETCH_EXAM_LAB_DETAILS = 'fetch-exam-lab-details',
  FETCH_EXAMS = 'fetch-exams',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  LAYOUT_CONTENT = 'layout-content',
  LAYOUT_EXAM_LAB_DETAILS = 'layout-exam-lab-details',
  LAYOUT_EXAM_LAB_LIST_EXAM_LAB_DETAILS = 'layout-exam-lab-list-exam-lab-details',
  LAYOUT_EXAMS_LAB_CARD_EXAM_LAB_DETAILS = 'layout-exams-lab-card-exam-lab-details',
  LAYOUT_EXAMS_LAB_DETAILS_EXAM_LAB_DETAILS = 'layout-exams-lab-details-exam-lab-details',
  LAYOUT_REPORT = 'layout-report',
  LOADER_ESTABLISHMENT = 'loader-establishment',
  LOADER_EXAM_LAB_TITLE_EXAM_LAB_DETAILS = 'loader-exam-lab-title-exam-lab-details',
  LOADER_LEFT_CARD_EXAM_LAB_DETAILS = 'loader-left-card-exam-lab-details',
  LOADER_REPORT = 'loader-report',
  PANEL_AVAILABLE = 'panel-available',
  PANEL_EXAM_CARD = 'panel-exam-card',
  PANEL_EXAM_LAB_DETAILS = 'panel-exam-lab-details',
  PANEL_EXAM_LAB_TITLE_LOADER_EXAM_LAB_DETAILS = 'panel-exam-lab-title-loader-exam-lab-details',
  PANEL_EXAM_LEFT_CARD = 'panel-exam-left-card',
  PANEL_EXAM_LIST = 'panel-exam-list',
  PANEL_EXAM_RIGHT_CARD = 'panel-exam-right-card',
  PANEL_EXAM_TITLE = 'panel-exam-title',
  PANEL_LEFT_CARD_LOADER_EXAM_LAB_DETAILS = 'panel-left-card-loader-exam-lab-details',
  PANEL_LOADER_ESTABLISHMENT = 'panel-loader-establishment',
  PANEL_LOADER_REPORT = 'panel-loader-report',
  PANEL_MESSAGE = 'panel-message',
  PANEL_PROCESSING = 'panel-processing',
  PANEL_REPORT = 'panel-report',
  PANEL_TABS = 'panel-tabs',
  PANEL_TITLE_LIST = 'panel-title-list',
  PDF_VIEWER_EXAM_DETAILS = 'pdf-viewer-exam-details',
  REPEATER_EXAMS_PROCESSING = 'repeater-exams-processing',
  TAB_CONTROL = 'tab-control',
  TAB_WITH_CONTENT_AVAILABLE = 'tab-with-content-available',
  TAB_WITH_CONTENT_PROCESSING = 'tab-with-content-processing',
  TEXT_TAB_REPORT_MESSAGE_EXAM_LAB_DETAILS = 'text-tab-report-message-exam-lab-details',
  TEXT_TITLE_LIST = 'text-title-list',
}
export { ExamLabDetailsAliases };
